import { RootState } from "@/redux/store";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const menuSlice = createSlice({
  name: "menu",
  initialState: {
    openItem: ["dashboard"],
    defaultId: "dashboard",
    openComponent: "buttons",
    drawerOpen: false,
    componentDrawerOpen: true,
  },
  reducers: {
    setActiveItem(state, action: PayloadAction<Array<string>>) {
      state.openItem = action.payload;
    },

    setActiveComponent(state, action: PayloadAction<string>) {
      state.openComponent = action.payload;
    },
    setDrawerOpen(state, action: PayloadAction<boolean>) {
      state.drawerOpen = action.payload;
    },
    setComponentDrawerOpen(state, action: PayloadAction<boolean>) {
      state.componentDrawerOpen = action.payload;
    },
  },
});

export const {
  setActiveItem,
  setActiveComponent,
  setDrawerOpen,
  setComponentDrawerOpen,
} = menuSlice.actions;

export const selectMenu = (state: RootState) => state.menu;

export default menuSlice.reducer;
